import unescape from 'lodash/unescape'
import escape from 'lodash/escape'
import { replaceNthSubstring } from '../../utils/replaceNthSubstring'

export const ATTRIBUTE_NAME = 'data-table-of-content'

export type Item = { slug: string; title: string }
export type EditingItem = Item & { nth: number; index: number }
export type UpdatedItem = EditingItem & { newSlug: string; newTitle: string }

export const getTableOfContent = (html: string): Item[] =>
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  [...html.matchAll(RegExp(ATTRIBUTE_NAME + '="([^|]*?)\\|(.*?)"', 'g'))].map((mathed) => ({
    slug: unescape(mathed[1]),
    title: unescape(mathed[2]),
  }))

export const validateSlug = (items: Item[], slug: string, isNew?: boolean) => {
  if (!slug) {
    return 'Required'
  }

  if (!slug.match(/^[a-z0-9-]*$/g)) {
    return 'Invalid format'
  }

  if (items.filter((item) => item.slug === slug).length >= (isNew ? 1 : 2)) {
    return 'Duplicated'
  }

  return undefined
}

export const validateTitle = (items: Item[], title: string, isNew?: boolean) => {
  if (!title) {
    return 'Required'
  }

  if (items.filter((item) => item.title === title).length >= (isNew ? 1 : 2)) {
    return 'Duplicated'
  }

  return undefined
}

export type ValidateTableOfContentOptions = { required?: boolean; minCount?: number; maxCount?: number }

export const validateTableOfContent = (
  items: Item[],
  options?: ValidateTableOfContentOptions
): { error?: string; errors: Array<{ slug?: string; title?: string }> } => {
  const errors = items.map(({ slug, title }) => ({
    slug: validateSlug(items, slug),
    title: validateTitle(items, title),
  }))

  if (options?.required && !items.length) {
    return {
      error: 'Required',
      errors,
    }
  }

  if (options?.minCount !== undefined && items.length < options.minCount) {
    return {
      error: `Must have at least ${options.minCount} items`,
      errors,
    }
  }

  if (options?.maxCount !== undefined && items.length > options.maxCount) {
    return {
      error: `Must have no more than ${options.maxCount} items`,
      errors,
    }
  }

  for (let i = 0; i < errors.length; i++) {
    if (errors[i].slug) {
      return {
        error: `Item #${i + 1} Slug: ${errors[i].slug}`,
        errors,
      }
    }

    if (errors[i].title) {
      return {
        error: `Item #${i + 1} Title: ${errors[i].title}`,
        errors,
      }
    }
  }

  return {
    error: undefined,
    errors,
  }
}

export const updateItemInHtml = ({ slug, title, newSlug, newTitle, nth }: UpdatedItem, html: string) =>
  replaceNthSubstring(
    html,
    `${ATTRIBUTE_NAME}="${escape(slug)}|${escape(title)}"`,
    `${ATTRIBUTE_NAME}="${escape(newSlug)}|${escape(newTitle)}"`,
    nth
  )
